// src/types/visa-prep-form/index.ts
var Relationship = /* @__PURE__ */ ((Relationship2) => {
  Relationship2["GUARDIAN"] = "GUARDIAN";
  Relationship2["FRIEND"] = "FRIEND";
  Relationship2["SISTER"] = "SISTER";
  Relationship2["BROTHER"] = "BROTHER";
  Relationship2["AUNT"] = "AUNT";
  Relationship2["UNCLE"] = "UNCLE";
  Relationship2["COUSIN"] = "COUSIN";
  Relationship2["GRANDPARENT"] = "GRANDPARENT";
  Relationship2["NON_DEPENDANT"] = "NON_DEPENDANT";
  Relationship2["OTHER"] = "OTHER";
  return Relationship2;
})(Relationship || {});
var MaritalStatus = /* @__PURE__ */ ((MaritalStatus2) => {
  MaritalStatus2["SINGLE"] = "SINGLE";
  MaritalStatus2["MARRIED"] = "MARRIED";
  MaritalStatus2["UNMARRIED"] = "UNMARRIED";
  MaritalStatus2["DIVORCED"] = "DIVORCED";
  MaritalStatus2["SEPARATED"] = "SEPARATED";
  MaritalStatus2["WIDOWED"] = "WIDOWED";
  return MaritalStatus2;
})(MaritalStatus || {});
var ShareCodeStatus = /* @__PURE__ */ ((ShareCodeStatus2) => {
  ShareCodeStatus2["NONE"] = "NONE";
  ShareCodeStatus2["VERIFIED"] = "VERIFIED";
  ShareCodeStatus2["NOT_VERIFIED"] = "NOT_VERIFIED";
  ShareCodeStatus2["EXPIRING_SOON"] = "EXPIRING_SOON";
  ShareCodeStatus2["EXPIRED"] = "EXPIRED";
  return ShareCodeStatus2;
})(ShareCodeStatus || {});

// src/types/index.ts
import {
  InfoState,
  CourseLevel
} from "platform-lib/fe-safe";

export {
  Relationship,
  MaritalStatus,
  ShareCodeStatus,
  InfoState,
  CourseLevel
};
